module.exports = __webpack_public_path__ + "img/perfil_normal.ac8c9678.jpg";